/**
 * FCM 푸시 토큰 API
 *
 * @CODE:CUSTOMER-WEBPUSH | SPEC: docs/superpowers/specs/2026-06-11-customer-realtime-fix-and-webpush-design.md
 */
import { apiClient } from './client';

export const pushApi = {
  /**
   * FCM 토큰 등록
   * POST /api/v1/push-tokens
   */
  registerToken: (token: string): Promise<unknown> =>
    apiClient.post('/api/v1/push-tokens', { token, platform: 'web' }),

  /**
   * FCM 토큰 삭제
   * DELETE /api/v1/push-tokens
   *
   * apiClient.delete 는 RequestOptions 를 받으며 body 는 fetchOptions 스프레드로 전달된다.
   */
  unregisterToken: (token: string): Promise<unknown> =>
    apiClient.delete('/api/v1/push-tokens', { body: JSON.stringify({ token }) }),

  /**
   * 픽업 비회원 — 주문 귀속 FCM 토큰 등록 (#694 Part C)
   * POST /api/v1/orders/{orderId}/push-token
   *
   * 등록 증명: 주문 생성 시 설정한 guest_password (기존 status 폴링과 동일 증명).
   */
  registerGuestOrderToken: (
    orderId: string | number,
    token: string,
    guestPassword: string
  ): Promise<unknown> =>
    apiClient.post(`/api/v1/orders/${orderId}/push-token`, {
      token,
      platform: 'web',
      guest_password: guestPassword,
    }),

  /**
   * 테이블 비회원 — 테이블 세션 귀속 FCM 토큰 등록 (#694 Part C, 결정 2: 세션 단위 귀속)
   * POST /api/v1/table-session/push-token
   *
   * sessionToken 을 명시 헤더로 전달 — 주문 완료 시점에 스냅샷된 값을 사용해
   * 등록 시점에 sessionStorage 가 바뀌어도 올바른 세션에 귀속된다 (#694 P2).
   * buildHeaders 의 customHeaders 는 자동 부착(sessionStorage 기반) 뒤에 Object.assign 으로
   * 병합되므로 명시 헤더가 우선한다 (client.ts L648-650 확인).
   */
  registerTableSessionToken: (token: string, sessionToken: string): Promise<unknown> =>
    apiClient.post(
      '/api/v1/table-session/push-token',
      { token, platform: 'web' },
      { headers: { 'X-Session-Token': sessionToken } }
    ),
};
